
import React from 'react';

import { Dialog } from '../../../../base/dialog';
import { translate } from '../../../../base/i18n';
import { connect } from '../../../../base/redux';
import AbstractStopLiveStreamDialog, {
    _mapStateToProps
} from '../AbstractStopLiveStreamDialog';

/**
 * A React Component for confirming the participant wishes to stop the currently
 * active live stream of the conference.
 *
 * @augments Component
 */
class StopLiveStreamDialog extends AbstractStopLiveStreamDialog {

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { t, _isRecordingandLivestreamingOn } = this.props;

        return (
            <Dialog
                okKey = { _isRecordingandLivestreamingOn ? 'dialog.stopLiveStreamRecording' : 'dialog.stopLiveStream' }
                onSubmit = { this._onSubmit }
                titleKey = { _isRecordingandLivestreamingOn ? 'dialog.stopLiveStreamRecording' : 'dialog.stopLiveStream' }
                width = 'small'>
                { t(_isRecordingandLivestreamingOn ? 'dialog.stopStreamingRecordingWarning' : 'dialog.stopStreamingWarning') }
            </Dialog>
        );
    }

    _onSubmit: () => boolean;
}

export default translate(connect(_mapStateToProps)(StopLiveStreamDialog));
